import { render } from "./PortfolioItemList.vue?vue&type=template&id=6a48dae1&ts=true"
import script from "./PortfolioItemList.vue?vue&type=script&lang=ts"
export * from "./PortfolioItemList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__